/* Senivya — chat d'aide maison (2026-10-24). Voir boutiques/senivya/chatbot-20261024/README.md du BRAIN. */
(function () {
  if (window.snvChatReady) return;
  window.snvChatReady = true;

  var root = document.getElementById('snvc');
  if (!root) return;
  root.insertAdjacentHTML('beforeend', `
  <section class="snvc-panel" id="snvc-panel" role="dialog" aria-modal="true" aria-label="Chat de ayuda Senivya" hidden>
    <header class="snvc-head">
      <div class="snvc-avatar" aria-hidden="true">S</div>
      <div><div class="snvc-title">Ayuda Senivya</div><div class="snvc-sub"><i></i>Te respondemos en menos de 24 h</div></div>
      <button class="snvc-x" type="button" aria-label="Cerrar el chat">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
    </header>
    <div class="snvc-body" aria-live="polite"></div>
    <div class="snvc-foot">
      <button type="button" data-act="home">Menú principal</button>
      <button type="button" data-act="track">Rastrear mi pedido</button>
    </div>
  </section>
`);
  var sinkFrame = document.createElement('iframe'); sinkFrame.name = 'snvc-sink'; sinkFrame.title = 'envío'; sinkFrame.tabIndex = -1;
  document.getElementById('snvc-contact-form').parentNode.appendChild(sinkFrame);
  var launch = root.querySelector('.snvc-launch');
  var panel = root.querySelector('.snvc-panel');
  var body = root.querySelector('.snvc-body');
  var teaser = root.querySelector('.snvc-teaser');
  var country = root.dataset.country || '';
  var tpl = root.dataset.template || '';
  var TRACK_URL = '/apps/parcelpanel';
  var MAIL = 'contact@senivya.com';
  var LIST_ID = 'VrkXYD';
  var COMPANY_ID = 'RWvMYq';
  var started = false;
  var quiz = {};

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  // ---------- Data : Klaviyo (gratuit, déjà payé) ----------
  function kTrack(name, props) {
    props = props || {};
    props.pais = country; props.pagina = tpl;
    try { (window.klaviyo = window.klaviyo || []).push(['track', name, props]); } catch (e) {}
  }
  function kIdentify(email, props) {
    if (!email) return;
    var p = { email: email };
    for (var k in props) if (props[k]) p[k] = props[k];
    try { (window.klaviyo = window.klaviyo || []).push(['identify', p]); } catch (e) {}
  }
  function kSubscribe(email, props) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Chat Senivya',
        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
      }, relationships: { list: { data: { type: 'list', id: LIST_ID } } } } })
    });
  }

  // ---------- Rendu ----------
  function scroll() { body.scrollTop = body.scrollHeight; }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function say(text, cb) {
    var t = el('div', 'snvc-msg snvc-bot snvc-typing', '<span></span><span></span><span></span>');
    body.appendChild(t); scroll();
    setTimeout(function () {
      t.className = 'snvc-msg snvc-bot'; t.innerHTML = text; scroll();
      if (cb) cb();
    }, Math.min(900, 350 + text.length * 4));
  }
  function sayAll(list, cb) {
    var i = 0;
    (function next() { if (i >= list.length) return cb && cb(); say(list[i++], next); })();
  }
  function me(text) { body.appendChild(el('div', 'snvc-msg snvc-me', null)).textContent = text; scroll(); }
  function chips(items) {
    var wrap = el('div', 'snvc-chips');
    items.forEach(function (it) {
      var b;
      if (it.href) { b = el('a', 'snvc-chip' + (it.solid ? ' snvc-chip--solid' : ''), null); b.href = it.href; b.textContent = it.label;
        b.addEventListener('click', function () { kTrack('Chat Senivya - Clic', { opcion: it.label }); });
      } else {
        b = el('button', 'snvc-chip' + (it.solid ? ' snvc-chip--solid' : ''), null); b.type = 'button'; b.textContent = it.label;
        b.addEventListener('click', function () {
          wrap.remove(); me(it.label); kTrack('Chat Senivya - Opción', { opcion: it.label, paso: it.step || '' });
          it.go();
        });
      }
      wrap.appendChild(b);
    });
    body.appendChild(wrap); scroll();
  }
  function trackLink(label) { return { label: label || 'Rastrear mi pedido', href: TRACK_URL, solid: true }; }

  // ---------- Parcours ----------
  function home(again) {
    say(again ? '¿Te ayudo con algo más?' : 'Hola. Soy el asistente de Senivya. ¿En qué te ayudo?', function () {
      chips([
        { label: '¿Dónde está mi pedido?', go: pedido },
        { label: 'Tengo un problema con mi pedido', go: problema },
        { label: 'Veo un cargo que no reconozco', go: cargo },
        { label: 'Costo y tiempo de envío', go: envio },
        { label: 'Ayúdame a elegir', go: elegir },
        { label: 'Hablar con el equipo', go: function () { form('Otra consulta'); } }
      ]);
    });
  }

  function pedido() {
    sayAll([
      'Preparamos tu pedido en 1 a 2 días hábiles. Después te llega en 7 a 15 días hábiles, casi siempre hacia el día 8.',
      'En cuanto sale, te mandamos el número de seguimiento por correo. Con tu número de pedido puedes ver dónde está ahora mismo.'
    ], function () {
      chips([
        trackLink(),
        { label: 'Pasaron más de 15 días hábiles', go: function () {
          say('Lo revisamos el mismo día. Déjanos tus datos y el equipo te escribe.', function () { form('Pedido con retraso (más de 15 días hábiles)'); });
        } },
        { label: 'Dice «entregado» pero no lo tengo', go: entregado },
        { label: 'No recibí el correo de seguimiento', go: function () {
          say('Revisa tu carpeta de spam o promociones: el correo viene de Senivya. ¿No está? Te lo mandamos de nuevo.', function () { form('No recibí el correo de seguimiento'); });
        } }
      ]);
    });
  }

  function entregado() {
    sayAll([
      'A veces el paquete se deja con un vecino, en la recepción o en un punto de recogida. Revisa también la dirección de tu confirmación.',
      '¿Nada? Escríbenos aquí y el equipo lo revisa.'
    ], function () { form('Dice entregado pero no lo recibí'); });
  }

  function problema() {
    say('Vamos a resolverlo. ¿Qué pasó?', function () {
      chips([
        { label: 'Llegó roto, defectuoso o equivocado', go: function () {
          say('Lo siento. Déjanos tus datos aquí y responde luego a nuestro correo con una foto del producto.',
            function () { form('Llegó roto, defectuoso o equivocado'); });
        } },
        { label: 'No es lo que esperaba', go: function () {
          say('Cuéntanos qué pasó y el equipo te responde.', function () { form('No es lo que esperaba'); });
        } },
        { label: 'Quiero cancelar mi pedido', go: function () {
          say('Escríbenos rápido con tu número de pedido y el equipo lo revisa.',
            function () { form('Cancelar pedido'); });
        } },
        { label: 'Quiero cambiar mi dirección', go: function () {
          say('La corregimos si tu pedido aún no salió. Escríbenos rápido con la dirección completa.',
            function () { form('Cambiar dirección de envío'); });
        } },
        { label: 'Otra cosa', go: function () { form('Otro problema con el pedido'); } }
      ]);
    });
  }

  function cargo() {
    sayAll([
      'Si ves un cargo que no reconoces, puede ser una compra en senivya.com. Busca en tu correo la confirmación de Senivya: ahí está tu número de pedido.',
      'Si sigues con dudas, escríbenos antes de llamar a tu banco. Lo resolvemos en 24 h, y un reclamo bancario tarda semanas.'
    ], function () {
      kTrack('Chat Senivya - Cargo no reconocido', {});
      form('Cargo no reconocido');
    });
  }

  function envio() {
    say('Ves el costo del envío en el carrito, antes de pagar. Te llega en 7 a 15 días hábiles, casi siempre hacia el día 8.', function () {
      chips([{ label: 'Volver al menú', go: function () { home(true); } }]);
    });
  }

  // ---------- Data client : 3 questions, puis e-mail facultatif ----------
  function elegir() {
    quiz = {};
    say('Te hago 3 preguntas rápidas. ¿Qué te gustaría mejorar?', function () {
      chips([
        { label: 'Mis pestañas', step: 'objetivo', go: function () { quiz.objetivo = 'pestanas'; edad(); } },
        { label: 'Mi mirada (sombras)', step: 'objetivo', go: function () { quiz.objetivo = 'sombras'; edad(); } },
        { label: 'Mi base de maquillaje', step: 'objetivo', go: function () { quiz.objetivo = 'base'; edad(); } },
        { label: 'Todavía no sé', step: 'objetivo', go: function () { quiz.objetivo = 'no_sabe'; edad(); } }
      ]);
    });
  }
  function edad() {
    say('¿Qué edad tienes?', function () {
      chips(['Menos de 35', '35 a 44', '45 a 54', '55 a 64', '65 o más'].map(function (r) {
        return { label: r, step: 'edad', go: function () { quiz.edad = r; canal(); } };
      }));
    });
  }
  function canal() {
    say('¿Cómo nos conociste?', function () {
      chips(['Facebook', 'Instagram', 'TikTok', 'Me lo recomendaron', 'Otro'].map(function (r) {
        return { label: r, step: 'canal', go: function () { quiz.canal = r; recomendar(); } };
      }));
    });
  }
  function recomendar() {
    var map = {
      pestanas: { t: 'Para tus pestañas, te recomiendo empezar por nuestra máscara.', href: '/products/senivya-mascara-til-modne-vipper-senivya-2-0', l: 'Ver la máscara' },
      sombras: { t: 'Para tu mirada, mira nuestro lápiz de sombra en barra.', href: '/products/ojenskygge-stift', l: 'Ver el lápiz de sombra' },
      base: { t: 'Para tu piel, mira nuestra base de maquillaje con SPF 50.', href: '/products/base-de-maquillaje-antiedad-con-spf-50-se-adapta-a-tu-tono-de-piel', l: 'Ver la base' },
      no_sabe: { t: 'Te dejo todos nuestros productos para que veas con calma.', href: '/collections/all', l: 'Ver los productos' }
    };
    var r = map[quiz.objetivo] || map.no_sabe;
    kTrack('Chat Senivya - Perfil', { objetivo: quiz.objetivo, edad: quiz.edad, canal: quiz.canal });
    say('Gracias. ' + r.t, function () {
      chips([{ label: r.l, href: r.href, solid: true }]);
      say('¿Quieres recibir consejos y ofertas por correo? Es opcional.', function () { optin(); });
    });
  }
  function optin() {
    var f = el('form', 'snvc-form');
    f.innerHTML =
      '<label>Tu correo<input type="email" name="email" required autocomplete="email" inputmode="email" placeholder="tu@correo.com"></label>' +
      '<label class="snvc-check"><input type="checkbox" name="ok" required> Acepto recibir correos de Senivya. Puedo darme de baja cuando quiera.</label>' +
      '<p class="snvc-err" hidden></p><button class="snvc-send" type="submit">Quiero recibirlos</button>';
    var em = f.querySelector('[name=email]'); em.value = root.dataset.email || '';
    body.appendChild(f);
    chips([{ label: 'No, gracias', go: function () { f.remove(); home(true); } }]);
    var noThanks = body.lastChild;
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('.snvc-send'), err = f.querySelector('.snvc-err');
      var props = { chat_objetivo: quiz.objetivo, chat_edad: quiz.edad, chat_canal: quiz.canal, chat_pais: country, fuente_alta: 'Chat Senivya' };
      btn.disabled = true; err.hidden = true;
      kSubscribe(em.value.trim(), props).then(function (res) {
        if (!res.ok) throw new Error(res.status);
        kIdentify(em.value.trim(), props);
        f.remove(); noThanks.remove();
        say('Listo. Revisa tu correo en unos minutos.', function () { home(true); });
      }).catch(function () {
        btn.disabled = false; err.textContent = 'No se pudo guardar. Revisa tu correo e inténtalo de nuevo.'; err.hidden = false;
      });
    });
    scroll();
  }

  // ---------- Formulaire SAV → contact@senivya.com (formulaire contact natif Shopify) ----------
  // Le captcha Shopify s'arme à l'affichage du formulaire. Son script envoie le formulaire avec sa propre copie de
  // submit() : seul un target vers un cadre invisible garantit que la cliente ne quitte jamais la page.
  // Réponse lisible + contact_posted=true = envoyé ; page « Desafío » (illisible) ou silence = repli e-mail.
  function armCaptcha() {
    var f = document.getElementById('snvc-contact-form');
    if (!f) return;
    f.target = 'snvc-sink';
    if (!f.dataset.hcaptchaBound && window.Shopify && Shopify.captcha && Shopify.captcha.protect) {
      try { Shopify.captcha.protect(f); } catch (e) {}
    }
  }
  function sendContact(data) {
    return new Promise(function (resolve, reject) {
      var f = document.getElementById('snvc-contact-form');
      var sink = root.querySelector('iframe[name=snvc-sink]');
      if (!f || !sink) return reject(new Error('no-form'));
      Object.keys(data).forEach(function (k) { var i = f.querySelector('[name="contact[' + k + ']"]'); if (i) i.value = data[k]; });
      var timer = setTimeout(function () { end(false); }, 15000);
      function end(ok) { clearTimeout(timer); sink.removeEventListener('load', onLoad); ok ? resolve() : reject(new Error('not-posted')); }
      function onLoad() {
        var href = '';
        try { href = sink.contentWindow.location.href; } catch (e) { return end(false); }
        if (href === 'about:blank') return;
        end(/contact_posted=true/.test(href));
      }
      sink.addEventListener('load', onLoad);
      armCaptcha();
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  }
  function kEvent(name, email, props) {
    props.pais = country; props.pagina = location.pathname;
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID, {
      method: 'POST', headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'event', attributes: { properties: props,
        metric: { data: { type: 'metric', attributes: { name: name } } },
        profile: { data: { type: 'profile', attributes: { email: email } } } } } })
    }).catch(function () {});
  }

  function form(motivo) {
    var f = el('form', 'snvc-form');
    f.innerHTML =
      '<label>Tu nombre<input type="text" name="name" required autocomplete="given-name"></label>' +
      '<label>Tu correo<input type="email" name="email" required autocomplete="email" inputmode="email"></label>' +
      '<label>Número de pedido (si lo tienes)<input type="text" name="order" inputmode="numeric" placeholder="#1234"></label>' +
      '<label>Tu mensaje<textarea name="msg" required placeholder="Cuéntanos en pocas palabras"></textarea></label>' +
      '<p class="snvc-err" hidden></p><button class="snvc-send" type="submit">Enviar al equipo</button>';
    f.querySelector('[name=name]').value = root.dataset.name || '';
    f.querySelector('[name=email]').value = root.dataset.email || '';
    body.appendChild(f); scroll(); armCaptcha();
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = function (n) { return f.querySelector('[name=' + n + ']').value.trim(); };
      var order = v('order').replace(/[^0-9]/g, '');
      var btn = f.querySelector('.snvc-send'), err = f.querySelector('.snvc-err');
      btn.disabled = true; err.hidden = true;
      var text = 'Motivo: ' + motivo + '\nPedido: ' + (order ? '#' + order : 'no indicado') + '\nCorreo: ' + v('email') +
        '\nPaís: ' + country + '\nPágina: ' + location.pathname + '\n\n' + v('msg') + '\n\n(Enviado desde el chat de senivya.com)';
      // Trace garantie du message (data + filet de sécurité), même si l'e-mail ne part pas.
      kEvent('Chat Senivya - Mensaje SAV', v('email'), { motivo: motivo, pedido: order ? '#' + order : '', nombre: v('name'), mensaje: v('msg') });
      kIdentify(v('email'), { chat_ultimo_motivo: motivo, chat_pais: country });
      sendContact({ name: v('name'), email: v('email'), Motivo: motivo, Pedido: order ? '#' + order : '', body: text }).then(function () {
        f.remove();
        say('Recibido. El equipo te responde por correo en menos de 24 h, de lunes a viernes. Revisa también tu carpeta de spam.', function () { home(true); });
      }).catch(function () {
        kTrack('Chat Senivya - Envío por correo', { motivo: motivo });
        var mail = 'mailto:' + MAIL + '?subject=' + encodeURIComponent(motivo + (order ? ' - pedido #' + order : '')) +
          '&body=' + encodeURIComponent(v('msg') + '\n\n' + v('name') + (order ? '\nPedido #' + order : ''));
        f.remove();
        say('Último paso: toca el botón para enviarnos tu mensaje desde tu correo. Ya está escrito, solo tienes que enviarlo.', function () {
          chips([{ label: 'Enviar desde mi correo', href: mail, solid: true }, { label: 'Volver al menú', go: function () { home(true); } }]);
        });
      });
    });
  }

  // ---------- Ouverture / fermeture ----------
  function open(source) {
    teaser.hidden = true; store('snvc_teased', '1');
    panel.hidden = false; launch.setAttribute('aria-expanded', 'true');
    if (window.matchMedia('(max-width:520px)').matches) document.documentElement.classList.add('snvc-lock');
    if (!started) { started = true; home(false); }
    kTrack('Chat Senivya - Abierto', { origen: source || 'boton' });
    setTimeout(function () { var x = panel.querySelector('.snvc-x'); if (x) x.focus({ preventScroll: true }); }, 50);
  }
  function close() {
    panel.hidden = true; launch.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('snvc-lock'); launch.focus({ preventScroll: true });
  }
  launch.addEventListener('click', function () { open('boton'); });
  panel.querySelector('.snvc-x').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  root.querySelector('[data-act=home]').addEventListener('click', function () { home(true); });
  root.querySelector('[data-act=track]').addEventListener('click', function () { kTrack('Chat Senivya - Clic', { opcion: 'Rastrear (pie)' }); location.href = TRACK_URL; });
  teaser.addEventListener('click', function (e) {
    if (e.target.tagName === 'BUTTON') { teaser.hidden = true; store('snvc_teased', '1'); return; }
    open('mensaje');
  });
  // Ouverture depuis n'importe quel lien : <a href="#chat"> ou window.snvChatOpen()
  window.snvChatOpen = open;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#chat"]');
    if (a) { e.preventDefault(); open('enlace'); }
  });

  // Barres collées en bas (CTA des LP, bandeaux) : la bulle et le petit message montent au-dessus, jamais par-dessus.
  // Un seul test elementsFromPoint, au plus toutes les 250 ms : coût négligeable.
  var liftTimer = null;
  function lift() {
    liftTimer = null;
    var h = window.innerHeight, lifted = 0, x = window.innerWidth - 43, ys = [h - 12, h - 35, h - 60, h - 85];
    ys.forEach(function (y) {
      (document.elementsFromPoint ? document.elementsFromPoint(x, y) : []).some(function (n) {
        if (n === document.documentElement || n === document.body || root.contains(n)) return false;
        for (var e = n; e && e !== document.body; e = e.parentElement) {
          var pos = getComputedStyle(e).position;
          if (pos === 'fixed' || pos === 'sticky') {
            var r = e.getBoundingClientRect();
            if (r.top < h && r.bottom > h - 100 && r.height < h / 3) lifted = Math.max(lifted, h - r.top);
            return true;
          }
        }
        return false;
      });
    });
    root.style.setProperty('--snvc-lift', lifted ? Math.round(lifted + 4) + 'px' : '0px');
  }
  // Deux passages : les barres qui arrivent en glissant (LP Stick) ne sont en place qu'après leur animation.
  var lateTimer = null;
  function queueLift() {
    if (!liftTimer) liftTimer = setTimeout(lift, 250);
    clearTimeout(lateTimer); lateTimer = setTimeout(lift, 900);
  }
  window.addEventListener('scroll', queueLift, { passive: true });
  window.addEventListener('resize', queueLift);
  setTimeout(lift, 800); setTimeout(lift, 3000);

  // Petit message une fois par session, sur la fiche produit seulement, après 25 s.
  if (/^product/.test(tpl) && !store('snvc_teased')) {
    setTimeout(function () { if (panel.hidden && !store('snvc_teased')) teaser.hidden = false; }, 25000);
  }
})();
